// extracted by mini-css-extract-plugin
module.exports = {"options":"Options_options__2cghm","button":"Options_button__1jK-n","favorite":"Options_favorite__hk3r9"};